export default defineNuxtPlugin(() => {
    const route = useRoute();

    (function (w, d, s, u) {
        w.RocketChat = function (c) { w.RocketChat._.push(c) };
        w.RocketChat._ = [];
        w.RocketChat.url = u;
        const h = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        j.async = true;
        j.src = 'https://chat.ismet.kz/livechat/rocketchat-livechat.min.js?_=201903270000';
        h.parentNode?.insertBefore(j, h);
    })(window, document, 'script', 'https://chat.ismet.kz/livechat');

    window.RocketChat(function () {
        const rc = this;
        let expanded = false
        const syncExpandedState = () => {
            document.querySelector('.rocketchat-widget')?.classList.toggle('app-chat-expanded', expanded)
        }

        rc.setDepartment('Work Ismet');
        rc.hideWidget();

        // Функция для проверки, нужно ли скрывать виджет на текущем роуте
        const shouldHide = () => {
            const path = window.location.pathname;
            return path === '/404' || path === '/';
        };

        rc.onWidgetHidden(function () {
            expanded = false
            syncExpandedState()
            const el = document.querySelector('.rocketchat-widget');
            if (el && !shouldHide()) {
                el.style.display = 'none';
            }
        });

        rc.onWidgetShown(function () {
            syncExpandedState()
            const el = document.querySelector('.rocketchat-widget');
            if (el) {
                el.style.display = 'block';
            }
        });

        rc.onChatMaximized(function () {
            expanded = true
            syncExpandedState()
        });

        rc.onChatMinimized(function () {
            expanded = false
            syncExpandedState()
            if (!shouldHide()) {
                rc.hideWidget();
            }
        });
    });
});
